
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { faceTempleteService } from "@/api/payments/faceTempleteService";
import { FaceTempletePaidDetailDto } from "@/api/service-proxies";

@Component({})
export default class FaceTempleteDetail extends Vue {

  @Prop()faceTemplete!: FaceTempletePaidDetailDto 

  created() {

  
  }

}
